module.exports = __webpack_public_path__ + "img/slide3_vn.9956d82d.jpg";